import { Typography } from '@mui/material';
import { tour_10 } from 'constants/tour';

/* import { Check } from '@mui/icons-material';*/
export const steps = [
  {
    selector: `.${tour_10.step_01}`,
    content: () => {
      return (
        <Typography>
          Definisci per ogni Spalla e Pila il tipo e il numero di elementi
          associati. Li ritroverai nelle sezioni &quot;Collegamenti&quot; della
          Struttura
        </Typography>
      );
    },
    /* style: {
      backgroundColor: '#bada55',
    }, */
  },
  {
    selector: `.${tour_10.step_02}`,
    content: () => {
      return (
        <Typography>
          Definisci per ogni Campata/Mensola/Trave tampone il tipo e il numero
          di elementi associati. Li ritroverai nelle sezioni
          &quot;Impalcato&quot; della Struttura
        </Typography>
      );
    },
  },
];
